import { Box, Container } from "@mui/material";
// import { BottomPage } from "components/BottomPagination";
// import { fetchNotices } from "components/FetchFunction";
// import MainLayout from "components/MainLayout";
// import { NoticeModal } from "components/modal/NoticeModal";
// import NoticeTable from "components/table/NoticeTable";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  queryOptionsState,
  selectedButtonState,
  selectedMenuState,
} from "../../recoil/index.ts";
import NoticeTable from "./NoticeTable.js";
import CustomButton from "../customComponent/CustomButton.tsx";
import { SearchComponent } from "../SearchComponent.tsx";
import { useNavigate } from "react-router-dom";
import { getNotices } from "common-lib";

export default function NoticePage() {
  const { t } = useTranslation();
  const setSelectedMenu = useSetRecoilState(selectedMenuState);
  const setSelectedButton = useSetRecoilState(selectedButtonState);
  const [queryOption, setQueryOption] = useRecoilState(queryOptionsState);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState("view");
  const [receivedData, setReceivedData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [searchType, setSearchType] = useState("title");
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedMenu(t("Notice"));
    setSelectedButton(t("Notice"));
  }, []);

  const fetchDatas = async () => {
    try {
      setLoading(true);
      const response = await getNotices({
        ...queryOption,
        keyword: keyword,
        search_type: searchType,
        page: currentPage,
        pageSize: 10,
      });
      setReceivedData(response.data.contents);
      setCount(response.data.total_count);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("searchType", searchType);
    console.log("keyword", keyword);
    fetchDatas();
  }, [queryOption, keyword, searchType]);

  useEffect(() => {
    if (!refresh) return;
    fetchDatas();
    setRefresh(false);
  }, [refresh]);

  return (
    <>
      <div className="p-8">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold text-gray-900">공지사항</h1>
        </div>
      </div>
      <Container
        className="middle-container"
        style={{ background: "var(--row-color)" }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "42px",
          }}
        >
          <CustomButton
            id="new-train-btn"
            text={t("CreateNotice")}
            variant="outlined"
            onClick={() => {
              navigate("/notice/create");
            }}
            // onClick={handleOpenModal}
          />
          <SearchComponent
            menu="notice"
            setPage={setCurrentPage}
            keyword={keyword}
            setKeyword={setKeyword}
            type={searchType}
            setType={setSearchType}
          />
        </Box>
        <NoticeTable
          receivedData={receivedData}
          loading={loading}
          setCount={setCount}
          total={count}
          currentPage={currentPage}
          setPage={setCurrentPage}
          setRefresh={setRefresh}
        />
      </Container>
      <Container style={{ background: "var(--row-color)" }}>
        {/* <BottomPage count={count} setCurrentPage={setCurrentPage} /> */}
      </Container>
      {/* <NoticeModal openModal={openModal} setOpenModal={setOpenModal} /> */}
    </>
  );
}
